import { render, staticRenderFns } from "./SquadForm.vue?vue&type=template&id=73b76027&scoped=true"
import script from "./SquadForm.vue?vue&type=script&lang=js"
export * from "./SquadForm.vue?vue&type=script&lang=js"
import style0 from "./SquadForm.vue?vue&type=style&index=0&id=73b76027&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b76027",
  null
  
)

export default component.exports